import { api } from '@/lib/api'
import type {
  CreateIntegrationSourceRequest,
  FieldMappingItem,
  IntegrationSource,
  UpdateIntegrationSourceRequest,
  WebhookLogItem,
} from './types'

export const integrationsApi = {
  listSources: async (): Promise<IntegrationSource[]> => {
    const r = await api.get<IntegrationSource[]>('/api/integrations/sources')
    return r.data
  },
  createSource: async (body: CreateIntegrationSourceRequest): Promise<IntegrationSource> => {
    const r = await api.post<IntegrationSource>('/api/integrations/sources', body)
    return r.data
  },
  webhookLog: async (sourceCode: string, limit = 50): Promise<WebhookLogItem[]> => {
    const r = await api.get<WebhookLogItem[]>(`/api/integrations/${sourceCode}/webhook-log`, {
      params: { limit },
    })
    return r.data
  },
  updateSource: async (code: string, body: UpdateIntegrationSourceRequest): Promise<IntegrationSource> => {
    const r = await api.patch<IntegrationSource>(`/api/integrations/sources/${code}`, body)
    return r.data
  },
  fieldMappings: async (sourceCode: string): Promise<FieldMappingItem[]> => {
    const r = await api.get<FieldMappingItem[]>(`/api/integrations/${sourceCode}/field-mappings`)
    return r.data
  },
}
